<template>
  <div id="BaseLoadingPage">
    <BaseHeader
      :theme="theme"
      :should-show-nav-icons="false"
      :should-show-search-controls="false"
      :should-show-main-menu="false"
    />
    <div class="loading-progress" />
    <div class="container loading-skeleton" role="status" aria-live="polite" aria-busy="true">
      <span class="sr-only">Loading</span>
      <div class="loading-skeleton__title" />
      <div class="loading-skeleton__line" />
      <div class="loading-skeleton__line loading-skeleton__line--short" />
      <div class="loading-skeleton__cards">
        <div v-for="n in 3" :key="n" class="loading-skeleton__card" />
      </div>
    </div>
  </div>
</template>
<script>
  import BaseHeader from "@/components/Header/BaseHeader"

  export default {
    components: {
      BaseHeader
    },
    props: {
      theme: {
        type: String,
        default: "Default"
      }
    }
  }

</script>

<style lang="scss" scoped>
  @use "../scss/variables";

  .loading-progress {
    position: relative;
    height: 3px;
    overflow: hidden;
    background: rgba(variables.$brand, 0.12);

    &::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 40%;
      background: variables.$brand;
      border-radius: 3px;
      animation: loading-progress-slide 1.2s infinite ease-in-out;
    }
  }

  .loading-skeleton {
    padding-top: 40px;

    &__title,
    &__line,
    &__card {
      border-radius: 6px;
      background: linear-gradient(90deg, #eef0f3 25%, #e1e4e9 50%, #eef0f3 75%);
      background-size: 200% 100%;
      animation: loading-shimmer 1.5s infinite ease-in-out;
    }

    &__title {
      width: 35%;
      height: 32px;
      margin-bottom: 24px;
    }

    &__line {
      height: 14px;
      margin-bottom: 12px;

      &--short {
        width: 60%;
      }
    }

    &__cards {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: 24px;
      margin-top: 32px;
    }

    &__card {
      height: 160px;
      border-radius: 10px;
    }
  }

  @keyframes loading-progress-slide {
    0% {
      left: -40%;
    }

    100% {
      left: 100%;
    }
  }

  @keyframes loading-shimmer {
    0% {
      background-position: 200% 0;
    }

    100% {
      background-position: -200% 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .loading-progress::after,
    .loading-skeleton__title,
    .loading-skeleton__line,
    .loading-skeleton__card {
      animation: none;
    }

    .loading-progress::after {
      left: 0;
      width: 100%;
      opacity: 0.4;
    }
  }
</style>
